import GradeLessonPage from '../components/GradeLessonPage';
import { grade2Topics } from './data';

export default function Grade2Page() {
  return (
    <GradeLessonPage
      grade="2"
      gradeLabel="Grade 2"
      gradeColor="rose"
      topics={grade2Topics}
      prevGrade={{ label: 'Grade 1', path: '/grade/1' }}
      nextGrade={{ label: 'Grade 3', path: '/grade/3' }}
    />
  );
}
